export const SET_PROVINCIAS_PARA_HOTELES = 'SET_PROVINCIAS_PARA_HOTELES';
export const UPDATE_BUSCADOR_HOTELES = 'UPDATE_BUSCADOR_HOTELES';
export const UPDATE_FECHA_IN_HOTELES = 'UPDATE_FECHA_IN_HOTELES';
export const REMOVE_HABITACION = 'REMOVE_HABITACION';
export const ADD_HABITACION = 'ADD_HABITACION';
export const SET_ADULTOS_CANTIDAD = 'SET_ADULTOS_CANTIDAD';
export const SET_MENORES_CANTIDAD = 'SET_MENORES_CANTIDAD';
export const SET_EDAD_MENORES = 'SET_EDAD_MENORES';
export const UPDATE_HABITACION = 'UPDATE_HABITACION';
export const UPDATE_BUSCADOR_HOTELES_Y_PASAJEROS = 'UPDATE_BUSCADOR_HOTELES_Y_PASAJEROS';
export const SET_PRODUCTO_SELECCIONADO = 'SET_PRODUCTO_SELECCIONADO';
export const SET_PASAJEROS_ADULTOS = 'SET_PASAJEROS_ADULTOS';
export const SET_PASAJEROS_MENORES = 'SET_PASAJEROS_MENORES';
export const SET_SEGURO_CANCELACION = 'SET_SEGURO_CANCELACION';
export const SET_REGIMEN_HOTEL = 'SET_REGIMEN_HOTEL';
export const SET_CDR_OFERTAS = 'SET_CDR_OFERTAS';
export const SET_INTERES = 'SET_INTERES';



// WEBPACK FOOTER //
// ./src/context/constantes.js